import type { MarkedOptions } from "marked";

// The dialects marked can be told to be, which is its three switches under the names people ask for them by. Pedantic
// is markdown.pl to the letter, bugs included, and turns GitHub's additions off with it.
export const FLAVOURS = [
  { value: "gfm", label: "GitHub Flavored", options: { gfm: true, breaks: false, pedantic: false } },
  { value: "gfm-breaks", label: "GitHub Flavored, Hard Breaks", options: { gfm: true, breaks: true, pedantic: false } },
  { value: "commonmark", label: "CommonMark", options: { gfm: false, breaks: false, pedantic: false } },
  { value: "original", label: "Original Markdown", options: { gfm: false, breaks: false, pedantic: true } },
] as const satisfies readonly Flavour[];

export const DEFAULT_FLAVOUR: FlavourId = "gfm";

// What the Select is handed: the icons and the options are the page's business and the dropdown's is the names.
export const FLAVOUR_OPTIONS = FLAVOURS.map(({ value, label }) => ({ value, label }));

export type FlavourId = typeof FLAVOURS[number]["value"];

interface Flavour {
  value: string;
  label: string;
  options: MarkedOptions;
}

export function isFlavour(value: string | null | undefined): value is FlavourId {
  return FLAVOURS.some((flavour) => flavour.value === value);
}

export function flavourOptions(flavour: FlavourId): MarkedOptions {
  return (FLAVOURS.find((entry) => entry.value === flavour) ?? FLAVOURS[0]).options;
}
